"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _recompose = require("recompose");

var _reactSelect = require("react-select");

var _withIcon = require("./custom-options/with-icon");

var _defaultOption = _interopRequireDefault(require("./custom-options/default-option"));

var _avatar = _interopRequireDefault(require("../../avatar"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CustomSingleValue = function CustomSingleValue(Component) {
  return (0, _recompose.setDisplayName)('CustomOption')(function (_ref) {
    var props = _extends({}, _ref);

    return (0, _core.jsx)(_reactSelect.components.SingleValue, props, (0, _core.jsx)(Component, props));
  });
};

var StyledAvatar = (
/*#__PURE__*/
0, _styledBase.default)(_avatar.default, {
  target: "e5gq3ej0"
})("height:20px;width:20px;margin-left:1px;margin-right:", function (props) {
  return props.theme.space[2];
}, "px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var AvatarSingleValue = function AvatarSingleValue(_ref2) {
  var data = _ref2.data,
      isDisabled = _ref2.isDisabled;
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(StyledAvatar, {
    url: data.image,
    size: "x-small",
    disabled: isDisabled,
    alt: "".concat(data.name, "'s avatar image'")
  }), (0, _core.jsx)(_defaultOption.default, {
    qaSelector: "".concat(data.value, " single-value"),
    label: data.label
  }));
};

var Icon = (0, _recompose.compose)((0, _recompose.branch)(function (_ref3) {
  var data = _ref3.data;
  return !R.has('icon', data);
}, _recompose.renderNothing), (0, _recompose.setDisplayName)('IconSingleValue'))(function (_ref4) {
  var data = _ref4.data,
      theme = _ref4.theme;
  return (0, _core.jsx)(_withIcon.StyledIcon, {
    icon: data.icon,
    width: "".concat(theme.iconSize, "px")
  });
});

var DefaultSingleValue = function DefaultSingleValue(_ref5) {
  var data = _ref5.data,
      theme = _ref5.theme;
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(Icon, {
    data: data,
    theme: theme
  }), (0, _core.jsx)(_defaultOption.default, {
    qaSelector: "".concat(data.value, " single-value"),
    label: data.label
  }));
};

var getSingleValueComponent = R.cond([[R.equals('individual'), R.always(AvatarSingleValue)], [R.T, R.always(DefaultSingleValue)]]);

var _default = function _default(decorator) {
  return CustomSingleValue(getSingleValueComponent(decorator));
};

exports.default = _default;